import { render, staticRenderFns } from "./jianyiview.vue?vue&type=template&id=0239980b&scoped=true"
import script from "./jianyiview.vue?vue&type=script&lang=js"
export * from "./jianyiview.vue?vue&type=script&lang=js"
import style0 from "./jianyiview.vue?vue&type=style&index=0&id=0239980b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239980b",
  null
  
)

export default component.exports